export enum Shadow {
	ExtraSmall = '0px 8px 12px -2px rgba(0, 73, 106, 0.16)',
	Small = '0px 9px 14px 0px rgba(63, 87, 109, 0.05)',
	Medium = '0px 4px 14px 0px rgba(63, 87, 109, 0.1)',
	Large = '0px 4px 34px 0px rgba(63, 87, 109, 0.24)',
	ExtraLarge = '0px 4px 94px 0px rgba(63, 87, 109, 0.14);',
	Desktop = '0px 2px 0px 0px rgba(0, 0, 0, 0.08), 0px 20px 24px -8px rgba(0, 73, 106, 0.12)',
	Mobile = '0px 2px 0px 0px rgba(0, 0, 0, 0.08), 0px 16px 24px -6px rgba(0, 73, 106, 0.08)',
	ImageContainerDesktop = '0px 22.92px 27.5px -13.75px #00496A1F',
	ImageContainerMobile = '0px 13.73px 16.47px -8.24px #00496A1F',
}
